import React, { useContext } from "react";
import { Box, Typography, Paper, Grid, Tab, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";

import LogoBarber from "../../assets/showcases/barber-logo.png";
import LogoSalon from "../../assets/showcases/salon-logo.png";
import LogoTrainer from "../../assets/showcases/trainer-logo.png";
import { UserContext } from "../../context/UserContext";
import LogoEcommerce from "../../assets/showcases/ecommerce-logo.png";
import LogoRestaurant from "../../assets/showcases/restaurant-logo.png";

const ShowcaseLoyaltyCard = ({
	cardBackgroundColor,
	tabStyle = "tabStyle1",
	cardTextColor,
	couponBackgroundColor,
	couponTextColor = "#000000",
	couponType,
}) => {
	const { creator } = useContext(CreatorContext);
	const { user } = useContext(UserContext);
	const { t } = useTranslation();

	// Simulated data for loyalty cards
	const loyaltyData = [
		{ amount: "5€", code: "LCOLU76SA4", expiry: "12 dec 2024" },
		{ amount: "5€", code: "LCMNL22AC2", expiry: "12 nov 2024" },
		{ amount: "10%", code: "DCYPL82ZQ1", expiry: "12 jan 2025" },
	];

	const getLogo = (sector) => {
		switch (sector) {
			case "barber":
				return LogoBarber;

			case "salon":
				return LogoSalon;

			case "trainer":
				return LogoTrainer;

			case "ecommerce":
				return LogoEcommerce;

			case "restaurant":
				return LogoRestaurant;
			default:
				return {};
		}
	};

	function hexToRGBA(hex, opacity) {
		let r = parseInt(hex.slice(1, 3), 16);
		let g = parseInt(hex.slice(3, 5), 16);
		let b = parseInt(hex.slice(5, 7), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFFFFF";
	};

	const AppointmentTabs = () => {
		return (
			<Box sx={{ width: "100%" }}>
				<Grid container spacing={0} sx={{ textAlign: "center" }}>
					<Grid
						item
						xs={4}
						sx={{
							cursor: "pointer",
							padding: "8px 0",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: tabStyle === "tabStyle1" ? "inherit" : creator.color,
								marginBottom: tabStyle === "tabStyle1" ? 0.5 : 0,
							}}
						>
							{t("vouchers.active")}
						</Typography>
						<Box
							sx={{
								borderBottom:
									tabStyle === "tabStyle1"
										? `1px solid ${creator.color}`
										: "none",
							}}
						></Box>
					</Grid>
					<Grid
						item
						xs={4}
						sx={{
							cursor: "pointer",
							padding: "8px 0",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#888",
							}}
						>
							{t("vouchers.used")}
						</Typography>
					</Grid>
					<Grid
						item
						xs={4}
						sx={{
							cursor: "pointer",
							padding: "8px 0",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#888",
							}}
						>
							{t("vouchers.past")}
						</Typography>
					</Grid>
				</Grid>
			</Box>
		);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				p: 1,
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			<Box
				sx={{
					bgcolor: cardBackgroundColor,
					p: 0,
					borderRadius: 2,
					padding: 1,
					minHeight: 100,
				}}
			>
				<Box
					sx={{
						position: "absolute",
						top: -60,
						left: 140,
						right: 0,
						width: 200,
						height: 200,
						backgroundImage:
							"linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(255,255,255,0.2))",
						borderRadius: "50%",
					}}
				/>
				<Typography
					variant="h6"
					sx={{
						fontSize: 12,
						textTransform: "inherit",
						fontWeight: "normal",
						color: cardTextColor,
					}}
				>
					Jane Smith
				</Typography>
				<Typography
					variant="body2"
					sx={{
						fontSize: 8,
						color: cardTextColor,
					}}
				>
					{t("loyalty.yourLoyalty")}
				</Typography>
				<Typography
					variant="body1"
					fontWeight="bold"
					sx={{
						fontSize: 8,
						color: cardTextColor,
					}}
				>
					ID12301239AMJ
				</Typography>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "flex-end",
						alignItems: "flex-end",
					}}
				>
					<img
						src={
							creator.appLogo
								? creator.appLogo
								: getLogo(user?.app?.appSubtype?.toLowerCase() ?? "barber")
						}
						alt={creator.appName}
						style={{ width: 50, height: "auto" }}
					/>
					<Typography
						variant="h5"
						fontWeight="bold"
						sx={{
							fontSize: 12,
							color: cardTextColor,
							textAlign: "rigth",
						}}
					>
						1200 {t("loyalty.points")}
					</Typography>
				</Box>
			</Box>
			<AppointmentTabs />
			<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
				{couponType === "coupon1" &&
					loyaltyData.map((item, index) => (
						<Box
							key={index}
							sx={{
								p: 1,
								borderRadius: "4px",
								display: "flex",
								flexDirection: "row",
								justifyContent: "space-between",
								backgroundColor: couponBackgroundColor,
								color: couponTextColor,
							}}
						>
							<Box>
								<Typography
									variant="h6"
									sx={{ fontWeight: "bold", color: couponTextColor }}
								>
									{item.amount}
								</Typography>
							</Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									gap: 0.5,
									textAlign: "right",
									flexDirection: "column",
								}}
							>
								<Typography variant="body1" sx={{ fontSize: "8px" }}>
									{t("loyalty.yourLoyaltyCode")}
								</Typography>
								<Typography
									variant="body2"
									sx={{
										fontSize: "10px",
										fontWeight: "bold",
										display: "inline-block",
										border: `1px dashed ${hexToRGBA(couponTextColor, 0.5)}`,
										borderColor: hexToRGBA(couponTextColor),
										textAlign: "center",
									}}
								>
									{item.code}
								</Typography>
								<Typography variant="body2" sx={{ fontSize: "8px" }}>
									{t("loyalty.expiredDate", { expiry: item.expiry })}
								</Typography>
							</Box>
						</Box>
					))}
				{couponType === "coupon2" &&
					loyaltyData.map((item, index) => (
						<Box
							key={index}
							sx={{
								p: 1,
								borderRadius: "4px",
								display: "flex",
								flexDirection: "row",
								justifyContent: "space-between",
								backgroundColor: couponBackgroundColor,
								color: couponTextColor,
								border: `1px dashed ${hexToRGBA(couponTextColor, 0.5)}`,
							}}
						>
							<Box>
								<Typography
									variant="h6"
									sx={{ fontWeight: "bold", color: couponTextColor }}
								>
									{item.amount}
								</Typography>
							</Box>
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									gap: 0.5,
									textAlign: "right",
									flexDirection: "column",
								}}
							>
								<Typography variant="body1" sx={{ fontSize: "8px" }}>
									{t("loyalty.yourLoyaltyCode")}
								</Typography>
								<Typography
									variant="body2"
									sx={{
										fontSize: "10px",
										fontWeight: "bold",
										display: "inline-block",
									}}
								>
									{item.code}
								</Typography>
								<Typography variant="body2" sx={{ fontSize: "8px" }}>
									{t("loyalty.expiredDate", { expiry: item.expiry })}
								</Typography>
							</Box>
						</Box>
					))}
				{couponType === "coupon3" && (
					<Grid container spacing={1}>
						{loyaltyData.map((item, index) => (
							<Grid item md={6}>
								<Box
									key={index}
									sx={{
										p: 1,
										borderRadius: "4px",
										display: "flex",
										flexDirection: "column",
										backgroundColor: couponBackgroundColor,
										color: couponTextColor,
										border: `1px solid ${hexToRGBA(couponTextColor, 0.5)}`,
									}}
								>
									<Box sx={{ textAlign: "center" }}>
										<Typography
											variant="h6"
											sx={{ fontWeight: "bold", color: couponTextColor }}
										>
											{item.amount}
										</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
											gap: 0.5,
											textAlign: "right",
											flexDirection: "column",
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: "8px",
												fontWeight: "bold",
												display: "inline-block",
												border: `1px dashed ${hexToRGBA(couponTextColor, 0.5)}`,
												textAlign: "center",
											}}
										>
											{item.code}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "7px" }}>
											{t("loyalty.expiredDate", { expiry: item.expiry })}
										</Typography>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				)}

				{couponType === "coupon4" && (
					<Grid container spacing={1}>
						{loyaltyData.map((item, index) => (
							<Grid item md={6}>
								<Box
									key={index}
									sx={{
										p: 1,
										borderRadius: "4px",
										display: "flex",
										flexDirection: "column",
										backgroundColor: couponBackgroundColor,
										color: couponTextColor,
										border: `1px dashed ${hexToRGBA(couponTextColor, 0.5)}`,
									}}
								>
									<Box sx={{ textAlign: "left" }}>
										<Typography
											variant="h6"
											sx={{ fontWeight: "bold", color: couponTextColor }}
										>
											{item.amount}
										</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
											gap: 0.5,
											textAlign: "left",
											flexDirection: "column",
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: "10px",
												fontWeight: "bold",
												display: "inline-block",
												textAlign: "left",
											}}
										>
											{item.code}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "7px" }}>
											{t("loyalty.expiredDate", { expiry: item.expiry })}
										</Typography>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				)}

				{couponType === "coupon5" && (
					<Grid container spacing={1}>
						{loyaltyData.map((item, index) => (
							<Grid item md={12}>
								<Box
									key={index}
									sx={{
										p: 1,
										borderRadius: "4px",
										display: "flex",
										flexDirection: "column",
										backgroundColor: couponBackgroundColor,
										color: couponTextColor,
										border: `1px solid ${hexToRGBA(couponTextColor, 0.5)}`,
									}}
								>
									<Box sx={{ textAlign: "center" }}>
										<Typography
											variant="h6"
											sx={{ fontWeight: "bold", color: couponTextColor }}
										>
											{item.amount}
										</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
											gap: 0.5,
											textAlign: "right",
											flexDirection: "column",
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: "10px",
												fontWeight: "bold",
												display: "inline-block",
												border: `1px dashed ${hexToRGBA(couponTextColor, 0.5)}`,
												textAlign: "center",
											}}
										>
											{item.code}
										</Typography>
										<Typography
											variant="body2"
											sx={{ fontSize: "7px", textAlign: "center" }}
										>
											{t("loyalty.expiredDate", { expiry: item.expiry })}
										</Typography>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				)}

				{couponType === "coupon6" && (
					<Grid container spacing={1}>
						{loyaltyData.map((item, index) => (
							<Grid item md={12}>
								<Box
									key={index}
									sx={{
										p: 1,
										borderRadius: "4px",
										display: "flex",
										flexDirection: "column",
										backgroundColor: couponBackgroundColor,
										color: couponTextColor,
									}}
								>
									<Box
										sx={{
											textAlign: "center",
											border: `1px solid ${hexToRGBA(couponTextColor, 0.5)}`,
										}}
									>
										<Typography
											variant="h6"
											sx={{ fontWeight: "bold", color: couponTextColor }}
										>
											{item.amount}
										</Typography>
										<Typography
											variant="body2"
											sx={{
												fontSize: "10px",
												fontWeight: "bold",
												display: "inline-block",
												textAlign: "center",
											}}
										>
											{item.code}
										</Typography>
									</Box>
									<Box
										sx={{
											display: "flex",
											justifyContent: "center",
											gap: 0.5,
											textAlign: "right",
											flexDirection: "column",
											marginTop: 1,
										}}
									>
										<Typography
											variant="body2"
											sx={{ fontSize: "7px", textAlign: "center" }}
										>
											{t("loyalty.expiredDate", { expiry: item.expiry })}
										</Typography>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				)}
			</Box>
		</Box>
	);
};

export default ShowcaseLoyaltyCard;
